import { BrowserRouter, Route, Routes } from 'react-router';
import { Home } from './routes/Home';
import { Create } from './routes/Create';
import { Edit } from './routes/Edit';
import { Play } from './routes/Play';
import { NotFound } from './routes/NotFound';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/create" element={<Create />} />
        <Route path="/random" element={<Play random />} />
        <Route path="/play/:slug" element={<Play />} />
        <Route path="/edit/:slug" element={<Edit />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
